export function setupPresentationVideos(root = document) {
  const container = root.querySelector("#vertical-presentation-videos");
  if (!container) return;

  const loadLazyVideo = (video) => {
    if (video.dataset.loaded) {
      return video.play();
    }

    video.querySelectorAll("source[data-src]").forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });

    video.load();
    video.dataset.loaded = "true";

    return video.play();
  };

  const markVideoPlaying = (video) => {
    const card = video.closest(".video-card");
    if (!card) return;

    card.classList.add("video-loaded");
    card.querySelector(".video-play-button")?.classList.remove("show");
  };

  const markVideoNeedsManualPlay = (video) => {
    video.closest(".video-card")
      ?.querySelector(".video-play-button")
      ?.classList.add("show");
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const video = entry.target;

      loadLazyVideo(video)
        .then(() => markVideoPlaying(video))
        .catch(() => markVideoNeedsManualPlay(video));

      observer.unobserve(video);
    });
  }, {
    rootMargin: "100px 0px"
  });

  root.querySelectorAll("#vertical-presentation-videos video.lazy-video").forEach((video) => {
    observer.observe(video);
  });

  root.querySelectorAll(".video-play-button").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const video = button.closest(".video-card")?.querySelector("video.lazy-video");
      if (!video) return;

      video.muted = true;

      loadLazyVideo(video)
        .then(() => markVideoPlaying(video))
        .catch(() => {});
    });
  });

  root.querySelectorAll(".vertical-presentation-videos-container a, .vertical-presentation-videos-container video, .vertical-presentation-videos-container img").forEach((el) => {
    el.setAttribute("draggable", "false");

    el.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupPresentationVideos(document);
});
